module.exports = __webpack_public_path__ + "static/img/msg-image-1.ec5a140.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/vpn/msg-image-1.png
// module id = RZEQ
// module chunks = 1